import { useContext } from 'react';
import AdapterHookContext from '../Context/AdapterHookContext';

const useAdapterHook = (entity, adapter, defaultConfig) => {
  const config = useContext(AdapterHookContext);
  return (config || defaultConfig)?.[entity]?.[adapter];
};

export default useAdapterHook;
